<template>
<w-settings-content-template>
  <div slot="content">
    <w-event-alarm-rule-tree :class="$style.side" @select-rule="selectRule"></w-event-alarm-rule-tree>
    <w-event-alarm-rule-table :class="$style.main" :selected-rule="selectedRule" :has-auth="true"></w-event-alarm-rule-table>
  </div>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WEventAlarmRuleTree from './components/EventAlarmRuleTree';
import WEventAlarmRuleTable from './components/EventAlarmRuleTable';

export default {
  name: 'WEventAlarmRuleSettings',
  components: {
    WSettingsContentTemplate,
    WEventAlarmRuleTree,
    WEventAlarmRuleTable,
  },
  data() {
    return {
      selectedRule: null,
    };
  },
  methods: {
    selectRule(selectedNode) {
      this.selectedRule = selectedNode;
    },
  },
};
</script>

<style module>
.side {
  width: 250px;
  margin-right: 20px;
  float: left;
}

.main {
  width: calc(100% - 270px);
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/index.vue